import React from 'react';
import RequirementAnswersSummary from './RequirementAnswersSummary';
import { formatDate } from './reviewerStages';

/**
 * The program terms an accepted nominee agreed to, read only: their
 * requirement answers, the exact commitments they agreed to and, for a
 * program's coordinator, the accuracy confirmation. `terms` is the
 * nomination's `terms` as the server sent it to this reader; null means the
 * nominee accepted before the terms were asked, and nothing is shown to
 * faculty, to whom the server sends no `terms` then.
 */
export default function NomineeTermsSummary({ terms, reviewer = false }) {
    if (terms === undefined) return null;
    if (terms === null) {
        return reviewer ? (
            <span className="d-block mt-1 small text-body-secondary">
                Accepted before the program terms were asked, so none are on
                file.
            </span>
        ) : null;
    }
    const { commitments } = terms;
    const statements = commitments?.statements || [];
    return (
        <span className="d-block mt-1">
            <span className="d-block small text-body-secondary">
                Program terms agreed to
            </span>
            {typeof terms.isReturning === 'boolean' && (
                <span className="d-block">
                    {terms.isReturning
                        ? 'Has held this role before (returning)'
                        : 'Has not held this role before (new)'}
                </span>
            )}
            {typeof terms.canAttendOrientation === 'boolean' && (
                <span className="d-block">
                    {`Orientation: ${terms.canAttendOrientation ? 'can attend' : 'cannot attend'}`}
                </span>
            )}
            {typeof terms.canAttendPedagogy === 'boolean' && (
                <span className="d-block">
                    {`Pedagogy seminar: ${terms.canAttendPedagogy ? 'can attend' : 'cannot attend'}`}
                </span>
            )}
            <RequirementAnswersSummary
                answers={terms.requirementAttestations}
            />
            {commitments && (
                <span className="d-block">
                    {commitments.acknowledged
                        ? commitments.acknowledgedAt
                            ? `Commitments: agreed on ${formatDate(commitments.acknowledgedAt)}`
                            : 'Commitments: agreed'
                        : 'Commitments: not agreed'}
                    {statements.length > 0 && (
                        <details className="mt-1">
                            <summary>
                                {`The ${statements.length} ${
                                    statements.length === 1
                                        ? 'statement'
                                        : 'statements'
                                } they agreed to`}
                            </summary>
                            <ol className="mb-0">
                                {statements.map((text) => (
                                    <li key={text}>{text}</li>
                                ))}
                            </ol>
                        </details>
                    )}
                </span>
            )}
            {reviewer && (
                <span className="d-block">
                    {terms.confirmsAccuracy
                        ? 'Confirmed their answers are accurate'
                        : 'Did not confirm their answers are accurate'}
                </span>
            )}
        </span>
    );
}
